export default __webpack_public_path__ + "static/media/stuart-marshall-bthere-2020-contributions.52c7d251.png";